import { Component, OnInit, NgZone, Renderer2, ElementRef } from '@angular/core';
import { VgAPI } from 'videogular2/compiled/core';
import { Media } from '../interfaces/media';
import { ProgramsService } from '../services/programs.service';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer} from '@angular/platform-browser';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { HttpHeaders } from '@angular/common/http';
import { PopoverController } from '@ionic/angular';
import { ProgramDetailsComponent } from '../components/program-details/program-details.component';

@Component({
  selector: 'app-media-player',
  templateUrl: './media-player.component.html',
  styleUrls: ['./media-player.component.scss'],
})
export class MediaPlayerComponent implements OnInit {
  preload = 'auto';
  api: VgAPI;

  playlist: Array<Media>;
  currentIndex = 0;
  currentItem: Media;
  programs: any;
  data: any;
  programIds: Array<any>;
  mediaPlayerTitle: string;
  elearningChannel: string;
  broadcastType: string;
  baseUrl: string;
  usergroup: string;
  channelId: string;
  apiKey: string;
  programKey: string;
  programImage: string;
  channelTitle: string;
  channelImage: string;
  shufflePrograms: boolean;
  shuffledPlaylist: any;

  constructor(
    private sanitizer: DomSanitizer,
    public ngZone: NgZone,
    private programService: ProgramsService,
    private authService: AuthService,
    private route: ActivatedRoute,
    public fontLibrary: FaIconLibrary,
    private router: Router,
    private popoverController: PopoverController,
    private renderer: Renderer2,
    public el: ElementRef) {
    this.fontLibrary.addIconPacks(fas);

    this.currentItem = {title: '', mediaFile: '', type: '', embed_code: '', live_broadcast: '', status: 'disabled', image: '', imageThumb: '', imageCheck: '', imageThumbCheck: '', description: '', author: '', storeUrl: '', broadcastType: '', rawImage: ''}
    this.route.queryParams.subscribe(params => {
      if (this.router.getCurrentNavigation().extras.state) {
      this.data = this.router.getCurrentNavigation().extras.state.channel;
      this.channelTitle = this.data.title;
      this.channelImage = this.data.channelImage;
      this.shufflePrograms = this.data.randomize;
      console.log('shuffle programs from nav', this.shufflePrograms);
      // } else {
      //   this.data = JSON.parse(localStorage.getItem('storedPrograms'));
      //   this.channelTitle = this.data.title;
      //   this.channelImage = this.data.channelImage;
      //   this.shufflePrograms = this.data.randomize;
      //   console.log('shuffle programs from storage', this.shufflePrograms);
      }

      // localStorage.setItem('storedPrograms', JSON.stringify(this.data));
      this.channelId = this.data.id;
      localStorage.setItem('channelId', this.channelId);
      this.elearningChannel = this.data.elearningChannel;
      this.broadcastType = this.data.broadcastType;
      this.usergroup = this.data.usergroup;
      this.playlist = [];
      this.programIds = this.data.programs.split(',');
      this.programIds.forEach(program => {
        this.programs = this.programService.getPrograms().on('value', programSnapshot => {
          programSnapshot.forEach(snap => {
            if (snap.val().state === '1' && snap.val().id.toString() === program.toString()) {
              this.playlist.push({
                title: snap.val().title,
                mediaFile: this.sanitizer.bypassSecurityTrustResourceUrl(snap.val().url),
                type: snap.val().file_type,
                broadcastType: snap.val().broadcast_type,
                embed_code: snap.val().embed_code,
                live_broadcast: snap.val().live_broadcast,
                status: 'disabled',
                rawImage: snap.val().image,
                image: this.baseUrl + '/' + snap.val().image,
                imageThumb: this.baseUrl + '/' + snap.val().image_thumb + '?api_key=' + this.apiKey,
                imageCheck: snap.val().image,
                imageThumbCheck: snap.val().image_thumb,
                description: snap.val().description,
                author: snap.val().author,
                storeUrl: snap.val().store_url
              });
            }
          });
          if (this.shufflePrograms) {
            console.log('play list in shuffle condition', this.playlist);
            this.shuffledPlaylist = this.shuffleArray(this.playlist);
            this.currentItem = this.shuffledPlaylist[ this.currentIndex ];
            this.currentItem.status = 'enabled';
          } else {
            this.shuffledPlaylist = this.playlist;
            this.currentItem = this.shuffledPlaylist[ this.currentIndex ];
            this.currentItem.status = 'enabled';
          }
        });
      });
      
    });
    console.log('playlist outside for loop', this.playlist);
    
  }

  ngOnInit() {
    
    this.mediaPlayerTitle = localStorage.getItem('mediaPlayerTitle');
    this.apiKey = localStorage.getItem('APIKey');
    this.baseUrl = localStorage.getItem('baseUrl');
    const httpHeaders = new HttpHeaders({
      'Content-Type' : 'application/json',
      'Authorization': 'BASIC ' + this.apiKey
    });
    const options = {
      headers: httpHeaders
    };
    
  }

  fileType(fileType) {
    return fileType.replace('-', '/');
  }

  shuffleArray(array) {
    let m = array.length, t, i;
  
    // While there remain elements to shuffle
    while (m) {
      // Pick a remaining element…
      i = Math.floor(Math.random() * m--);
  
      // And swap it with the current element.
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
  
    return array;
  }

  onPlayerReady(api: VgAPI) {
    console.log('vgapi', api);
    this.api = api;
    
    this.api.getDefaultMedia().subscriptions.ended.subscribe(
        this.nextVideo.bind(this)
    );

    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(
        this.playVideo.bind(this)
    );
  }

  playVideo() {
    this.api.play();
  }

  nextVideo() {
    console.log('current index', this.currentIndex);
    this.currentIndex++;
    console.log('current index advanced', this.currentIndex);
    if (this.currentIndex === this.playlist.length) {
        this.currentIndex = 0;
    }

    this.currentItem = this.playlist[ this.currentIndex ];
    this.currentItem.status = 'enabled';
    this.playVideo.bind(this);
  }

  onClickPlaylistItem(item: Media, index) {
    if (this.broadcastType === 'ondemand' || (this.broadcastType === 'elearning' && item.status === 'enabled')) {
      this.currentIndex = index;
      this.currentItem = item;
    }
  }

  // TODO save current video status to user's elearning profile. Enable link to quiz.

  logout() {
    this.authService.logoutUser();
    this.router.navigateByUrl('login');
  }

  async getProgramDetails(title, author, description, storeUrl) {
    const popover = await this.popoverController.create({
      component: ProgramDetailsComponent,
      translucent: true,
      componentProps: {
        title: title,
        author: author,
        description: description,
        storeUrl: storeUrl
      }
    });
    return await popover.present();
  }

  showStoredPrograms() {
    const storedPrograms = JSON.parse(localStorage.getItem('storedPrograms'));
  }

}
